import React from "react";
import { formatCurrency } from "./calculationUtils";
import { okkaliUnitPrices } from "./constants";

export default function ProductResultCard({
  product,
  productState,
  productName,
}) {
  return (
    <div className="bg-white border border-gray-200 rounded-2xl shadow-sm p-4 sm:p-5">
      <h3 className="text-base font-bold text-gray-900 mb-4">{productName}</h3>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="bg-emerald-50/80 border border-emerald-100/80 rounded-xl p-4">
          <div className="text-[11px] font-semibold tracking-wider text-emerald-600 uppercase">
            Okkalı Kahve Birim Fiyat
          </div>
          <div className="text-2xl font-bold text-emerald-800 mt-1.5">
            {formatCurrency(
              productState.okkaliBirimFiyat || okkaliUnitPrices[product]
            )}
          </div>
        </div>

        <div className="bg-amber-50/80 border border-amber-100/80 rounded-xl p-4">
          <div className="text-[11px] font-semibold tracking-wider text-amber-600 uppercase">
            Diğer Makine Birim Fiyat
          </div>
          <div className="text-2xl font-bold text-amber-800 mt-1.5">
            {formatCurrency(productState.digerBirimFiyat || "0")}
          </div>
        </div>
      </div>
    </div>
  );
}
